import {
    useCallback,
    useState,
} from 'react'
import {
    useMutation,
} from '@tanstack/react-query'

import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import simpleApi from 'app/services/simpleApi'
import {
    ChangeApprovalRequestStatus,
} from 'app/enums/label.enums'

type Params = {
    requestParamFn: (id)=> Record<string, any>,
    notificationId: string,
    data?: {
        orderNumber: string,
        changeApprovalRequestStatus: ChangeApprovalRequestStatus,
        version: number,
        requestedPickup?: string,
        estimatedPickup?: string,
    },
    onSuccess?: (props?: any) => void
}

const useRequestWithConfirmation = ({
    requestParamFn,
    notificationId,
    data,
    onSuccess,
}: Params) => {
    const token = useJWTToken()
    const [
        openConfirmDialog,
        setOpenConfirmDialog,
    ] = useState(false)

    const {
        onSuccess: onSuccessAction,
        onError,
    } = useHandleStatusRequest({
        id: notificationId,
        onSuccess,
    })

    const mutation = useMutation({
        mutationFn: (orderNumber) => {
            return simpleApi({
                ...requestParamFn({
                    orderNumber,
                }),
                data,
                token,
            })
        },
        onSuccess: onSuccessAction,
        onError,
    })

    const askConfirmation = useCallback(() => {
        setOpenConfirmDialog(true)
    }, [])

    const doAction = useCallback((confirm) => {
        if (confirm) {
            mutation.mutate(
                data.orderNumber,
            )
        }
        setOpenConfirmDialog(false)
    }, [
        mutation,
        data,
    ])

    return {
        askConfirmation,
        openConfirmDialog,
        doAction,
        onSuccess: onSuccessAction,
        isPending: mutation.isPending,
    }
}

export default useRequestWithConfirmation
